<template>
    <p
        class="text-fontDimmed"
        style="font-size: 14px; margin-bottom: 1rem; line-height: 1.625"
    >
        Thank you for signing up. Your workspace is being created.
    </p>
    <p
        class="text-fontDimmed"
        style="font-size: 14px; margin-bottom: 1rem; line-height: 1.625"
    >
        This mobile experience is a simplified version, in which you can:
    </p>
    <ul
        style="margin-left: 1.25rem; margin-bottom: 1rem; list-style-type: disc"
    >
        <li class="text-fontDimmed" style="margin-bottom: 0.5rem">
            <strong class="text-fontLight">Invite team members:</strong> Add
            team members to your organization and manage their access.
            <RouterLink
                class="link-text font-italic"
                :to="{ name: ROUTE_NAMES.MOBILE_INVITE_TEAM }"
                @click="emit('linkClick')"
                >Go now.</RouterLink
            >
        </li>
        <li class="text-fontDimmed" style="margin-bottom: 0.5rem">
            <strong class="text-fontLight">Get guided help:</strong> Book a
            session with the Kaamfu team for onboarding assistance, data
            migration, or a demonstration.
            <RouterLink
                class="link-text font-italic"
                :to="{ name: ROUTE_NAMES.MOBILE_GET_HELP }"
                @click="emit('linkClick')"
                >Go now.</RouterLink
            >
        </li>
    </ul>
    <p class="text-fontDimmed" style="font-size: 14px; margin-top: 1rem">
        <strong class="text-fontLight"
            >We have also emailed you a link to continue on desktop when you are
            ready.</strong
        >
        Desktop access is required for full access to work, settings, time
        tracking, conversations, AI-powered insights, reports, and more.
    </p>
</template>

<script setup>
import { RouterLink } from "vue-router";
import { ROUTE_NAMES } from "Admin/js/Constants/routes";

const emit = defineEmits(["linkClick"]);
</script>
<style scoped lang="scss">
.link-text {
    color: rgb(var(--v-theme-fontLink));
    text-decoration: none;
}
</style>
